<app-dialog-container
  [title]="'transferProduct' | translate"
  [confirmButtonDisabled]="!departmentControl.value || !quantityControl.value"
  (confirmButtonHandler)="onTransfer()"
  confirmButtonText="{{ 'transfer' | translate }}"
>
  <app-ui-select
    [label]="'selectTargetDepartment' | translate"
    [control]="departmentControl"
    [options]="availableDepartments()"
    [required]="true"
    [isMultiple]="false"
  ></app-ui-select>

  @if (departmentControl.value) {
    <app-ui-select
      [label]="'selectMatchingProduct' | translate"
      [control]="targetProductControl"
      [options]="targetProducts()"
      [required]="false"
      [isMultiple]="false"
      [enableSearch]="true"
    ></app-ui-select>
  }

  <app-ui-input
    [label]="'quantity' | translate"
    [control]="quantityControl"
    type="number"
    [required]="true"
  ></app-ui-input>

  <app-ui-text-area
    [label]="'reasonForTransfer' | translate"
    [control]="reasonControl"
  ></app-ui-text-area>
</app-dialog-container>
